/**
 * Frontend timezone utilities - hardcoded timezone data for reliable loading
 */

export interface Timezone {
  value: string;
  label: string;
  group: string;
  utcOffset: string;
  displayText: string;
}

// Hardcoded timezone data - no API dependency needed
export const AVAILABLE_TIMEZONES: Timezone[] = [
  // Universal
  { 
    value: 'UTC', 
    label: 'UTC - Coordinated Universal Time', 
    group: 'Universal',
    utcOffset: '+00:00',
    displayText: 'UTC - Coordinated Universal Time (+00:00)'
  },
  { 
    value: 'GMT', 
    label: 'GMT - Greenwich Mean Time', 
    group: 'Universal',
    utcOffset: '+00:00',
    displayText: 'GMT - Greenwich Mean Time (+00:00)'
  },
  
  // Asia - Southeast Asia
  { 
    value: 'Asia/Jakarta', 
    label: 'Asia/Jakarta - Western Indonesia Time (WIB)', 
    group: 'Asia/Southeast',
    utcOffset: '+07:00',
    displayText: 'Asia/Jakarta - Western Indonesia Time (WIB) (+07:00)'
  },
  { 
    value: 'Asia/Makassar', 
    label: 'Asia/Makassar - Central Indonesia Time (WITA)', 
    group: 'Asia/Southeast',
    utcOffset: '+08:00',
    displayText: 'Asia/Makassar - Central Indonesia Time (WITA) (+08:00)'
  },
  { 
    value: 'Asia/Jayapura', 
    label: 'Asia/Jayapura - Eastern Indonesia Time (WIT)', 
    group: 'Asia/Southeast',
    utcOffset: '+09:00',
    displayText: 'Asia/Jayapura - Eastern Indonesia Time (WIT) (+09:00)'
  },
  { 
    value: 'Asia/Singapore', 
    label: 'Asia/Singapore - Singapore Time', 
    group: 'Asia/Southeast',
    utcOffset: '+08:00',
    displayText: 'Asia/Singapore - Singapore Time (+08:00)'
  },
  { 
    value: 'Asia/Kuala_Lumpur', 
    label: 'Asia/Kuala_Lumpur - Malaysia Time', 
    group: 'Asia/Southeast',
    utcOffset: '+08:00',
    displayText: 'Asia/Kuala_Lumpur - Malaysia Time (+08:00)'
  },
  { 
    value: 'Asia/Bangkok', 
    label: 'Asia/Bangkok - Indochina Time', 
    group: 'Asia/Southeast',
    utcOffset: '+07:00',
    displayText: 'Asia/Bangkok - Indochina Time (+07:00)'
  },
  { 
    value: 'Asia/Manila', 
    label: 'Asia/Manila - Philippine Time', 
    group: 'Asia/Southeast',
    utcOffset: '+08:00',
    displayText: 'Asia/Manila - Philippine Time (+08:00)'
  },
  { 
    value: 'Asia/Ho_Chi_Minh', 
    label: 'Asia/Ho_Chi_Minh - Vietnam Time', 
    group: 'Asia/Southeast',
    utcOffset: '+07:00',
    displayText: 'Asia/Ho_Chi_Minh - Vietnam Time (+07:00)'
  },
  
  // Asia - East Asia
  { 
    value: 'Asia/Tokyo', 
    label: 'Asia/Tokyo - Japan Standard Time', 
    group: 'Asia/East',
    utcOffset: '+09:00',
    displayText: 'Asia/Tokyo - Japan Standard Time (+09:00)'
  },
  { 
    value: 'Asia/Seoul', 
    label: 'Asia/Seoul - Korea Standard Time', 
    group: 'Asia/East',
    utcOffset: '+09:00',
    displayText: 'Asia/Seoul - Korea Standard Time (+09:00)'
  },
  { 
    value: 'Asia/Shanghai', 
    label: 'Asia/Shanghai - China Standard Time', 
    group: 'Asia/East',
    utcOffset: '+08:00',
    displayText: 'Asia/Shanghai - China Standard Time (+08:00)'
  },
  { 
    value: 'Asia/Hong_Kong', 
    label: 'Asia/Hong_Kong - Hong Kong Time', 
    group: 'Asia/East',
    utcOffset: '+08:00',
    displayText: 'Asia/Hong_Kong - Hong Kong Time (+08:00)'
  },
  { 
    value: 'Asia/Taipei', 
    label: 'Asia/Taipei - Taiwan Time', 
    group: 'Asia/East',
    utcOffset: '+08:00',
    displayText: 'Asia/Taipei - Taiwan Time (+08:00)'
  },
  
  // Asia - South Asia
  { 
    value: 'Asia/Kolkata', 
    label: 'Asia/Kolkata - India Standard Time', 
    group: 'Asia/South',
    utcOffset: '+05:30',
    displayText: 'Asia/Kolkata - India Standard Time (+05:30)'
  },
  { 
    value: 'Asia/Dhaka', 
    label: 'Asia/Dhaka - Bangladesh Standard Time', 
    group: 'Asia/South',
    utcOffset: '+06:00',
    displayText: 'Asia/Dhaka - Bangladesh Standard Time (+06:00)'
  },
  { 
    value: 'Asia/Karachi', 
    label: 'Asia/Karachi - Pakistan Standard Time', 
    group: 'Asia/South',
    utcOffset: '+05:00',
    displayText: 'Asia/Karachi - Pakistan Standard Time (+05:00)'
  },
  
  // Asia - West Asia
  { 
    value: 'Asia/Dubai', 
    label: 'Asia/Dubai - Gulf Standard Time', 
    group: 'Asia/West',
    utcOffset: '+04:00',
    displayText: 'Asia/Dubai - Gulf Standard Time (+04:00)'
  },
  { 
    value: 'Asia/Riyadh', 
    label: 'Asia/Riyadh - Arabia Standard Time', 
    group: 'Asia/West',
    utcOffset: '+03:00',
    displayText: 'Asia/Riyadh - Arabia Standard Time (+03:00)'
  },
  
  // Europe
  { 
    value: 'Europe/London', 
    label: 'Europe/London - Greenwich Mean Time', 
    group: 'Europe',
    utcOffset: '+00:00',
    displayText: 'Europe/London - Greenwich Mean Time (+00:00)'
  },
  { 
    value: 'Europe/Paris', 
    label: 'Europe/Paris - Central European Time', 
    group: 'Europe',
    utcOffset: '+01:00',
    displayText: 'Europe/Paris - Central European Time (+01:00)'
  },
  { 
    value: 'Europe/Berlin', 
    label: 'Europe/Berlin - Central European Time', 
    group: 'Europe',
    utcOffset: '+01:00',
    displayText: 'Europe/Berlin - Central European Time (+01:00)'
  },
  { 
    value: 'Europe/Rome', 
    label: 'Europe/Rome - Central European Time', 
    group: 'Europe',
    utcOffset: '+01:00',
    displayText: 'Europe/Rome - Central European Time (+01:00)'
  },
  { 
    value: 'Europe/Amsterdam', 
    label: 'Europe/Amsterdam - Central European Time', 
    group: 'Europe',
    utcOffset: '+01:00',
    displayText: 'Europe/Amsterdam - Central European Time (+01:00)'
  },
  { 
    value: 'Europe/Moscow', 
    label: 'Europe/Moscow - Moscow Time', 
    group: 'Europe',
    utcOffset: '+03:00',
    displayText: 'Europe/Moscow - Moscow Time (+03:00)'
  },
  
  // Americas - North America
  { 
    value: 'America/New_York', 
    label: 'America/New_York - Eastern Time', 
    group: 'Americas/North',
    utcOffset: '-04:00',
    displayText: 'America/New_York - Eastern Time (-04:00)'
  },
  { 
    value: 'America/Chicago', 
    label: 'America/Chicago - Central Time', 
    group: 'Americas/North',
    utcOffset: '-05:00',
    displayText: 'America/Chicago - Central Time (-05:00)'
  },
  { 
    value: 'America/Denver', 
    label: 'America/Denver - Mountain Time', 
    group: 'Americas/North',
    utcOffset: '-06:00',
    displayText: 'America/Denver - Mountain Time (-06:00)'
  },
  { 
    value: 'America/Los_Angeles', 
    label: 'America/Los_Angeles - Pacific Time', 
    group: 'Americas/North',
    utcOffset: '-07:00',
    displayText: 'America/Los_Angeles - Pacific Time (-07:00)'
  },
  { 
    value: 'America/Toronto', 
    label: 'America/Toronto - Eastern Time', 
    group: 'Americas/North',
    utcOffset: '-04:00',
    displayText: 'America/Toronto - Eastern Time (-04:00)'
  },
  { 
    value: 'America/Vancouver', 
    label: 'America/Vancouver - Pacific Time', 
    group: 'Americas/North',
    utcOffset: '-07:00',
    displayText: 'America/Vancouver - Pacific Time (-07:00)'
  },
  
  // Americas - South America
  { 
    value: 'America/Sao_Paulo', 
    label: 'America/Sao_Paulo - Brasilia Time', 
    group: 'Americas/South',
    utcOffset: '-03:00',
    displayText: 'America/Sao_Paulo - Brasilia Time (-03:00)'
  },
  { 
    value: 'America/Argentina/Buenos_Aires', 
    label: 'America/Buenos_Aires - Argentina Time', 
    group: 'Americas/South',
    utcOffset: '-03:00',
    displayText: 'America/Buenos_Aires - Argentina Time (-03:00)'
  },
  { 
    value: 'America/Lima', 
    label: 'America/Lima - Peru Time', 
    group: 'Americas/South',
    utcOffset: '-05:00',
    displayText: 'America/Lima - Peru Time (-05:00)'
  },
  
  // Australia & Oceania
  { 
    value: 'Australia/Sydney', 
    label: 'Australia/Sydney - Australian Eastern Time', 
    group: 'Australia',
    utcOffset: '+10:00',
    displayText: 'Australia/Sydney - Australian Eastern Time (+10:00)'
  },
  { 
    value: 'Australia/Melbourne', 
    label: 'Australia/Melbourne - Australian Eastern Time', 
    group: 'Australia',
    utcOffset: '+10:00',
    displayText: 'Australia/Melbourne - Australian Eastern Time (+10:00)'
  },
  { 
    value: 'Australia/Perth', 
    label: 'Australia/Perth - Australian Western Time', 
    group: 'Australia',
    utcOffset: '+08:00',
    displayText: 'Australia/Perth - Australian Western Time (+08:00)'
  },
  { 
    value: 'Australia/Adelaide', 
    label: 'Australia/Adelaide - Australian Central Time', 
    group: 'Australia',
    utcOffset: '+09:30',
    displayText: 'Australia/Adelaide - Australian Central Time (+09:30)'
  },
  { 
    value: 'Pacific/Auckland', 
    label: 'Pacific/Auckland - New Zealand Time', 
    group: 'Pacific',
    utcOffset: '+12:00',
    displayText: 'Pacific/Auckland - New Zealand Time (+12:00)'
  },
  
  // Africa
  { 
    value: 'Africa/Cairo', 
    label: 'Africa/Cairo - Eastern European Time', 
    group: 'Africa',
    utcOffset: '+02:00',
    displayText: 'Africa/Cairo - Eastern European Time (+02:00)'
  },
  { 
    value: 'Africa/Johannesburg', 
    label: 'Africa/Johannesburg - South Africa Time', 
    group: 'Africa',
    utcOffset: '+02:00',
    displayText: 'Africa/Johannesburg - South Africa Time (+02:00)'
  },
  { 
    value: 'Africa/Lagos', 
    label: 'Africa/Lagos - West Africa Time', 
    group: 'Africa',
    utcOffset: '+01:00',
    displayText: 'Africa/Lagos - West Africa Time (+01:00)'
  }
];

// Group timezones by region for better UI organization
export const getGroupedTimezones = (): Record<string, Timezone[]> => {
  const grouped: Record<string, Timezone[]> = {};
  
  AVAILABLE_TIMEZONES.forEach(tz => {
    if (!grouped[tz.group]) {
      grouped[tz.group] = [];
    }
    grouped[tz.group].push(tz);
  });
  
  return grouped;
};

// Get default timezone (can be overridden by environment)
export const getDefaultTimezone = (): string => {
  // In a real app, you might want to detect user's timezone
  // For now, we'll default to UTC for safety
  return 'UTC';
};

// Validate if a timezone value exists in our list
export const isValidTimezone = (timezone: string): boolean => {
  return AVAILABLE_TIMEZONES.some(tz => tz.value === timezone);
};

// Find timezone by value
export const findTimezone = (value: string): Timezone | undefined => {
  return AVAILABLE_TIMEZONES.find(tz => tz.value === value);
};
